import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {EntityForm} from '@catuimodels/shared/entity-form';
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {SelectOption} from "@catuiform/types";
import {isNullOrUndefined} from "util";
import {Feature} from "@catcore/services/feature/feature";
import {FeatureTypeService} from "@catcore/services";
import {Router} from "@angular/router";
import {InputText, SelectItem} from "primeng/primeng";
import {InputTextComponent} from "@catuiform/components/input-text/input-text.component";
import {Subscription} from "rxjs";
import {FeatureOptionToken} from "@catmodels/feature-option-tokens/types";
import {UpdateService} from "@catcore/services/update.service";
import {FeatureGgwDevicesService} from "@catmodels/ggw-device/services/feature-ggw-devices.service";

const componentBaseName = 'feature-ggw-device-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-ggw-device-form',
  templateUrl: './feature-ggw-device-form.component.html',
  styleUrls: ['./feature-ggw-device-form.component.scss']
})
export class FeatureGgwDeviceFormComponent extends EntityForm implements OnInit, OnDestroy {
  @HostBinding('class') classNames = defaultClassNames;
  featureUnitOptions: SelectOption[];

  private currentResourceService;

  private featureSubscription;
  feature: Feature;

  private optionTokens: any[];
  private optionTokenSubscription: Subscription;

  optionTokensOptions: SelectItem[] = null;
  includeExcludeOptions: SelectItem[] = [];

  labels = {
    unit: 'Unit',
    force_exclude: 'Force exclude from GUI',
    aircraft_device: 'Aircraft Device',
    always_in_group: 'Always in Group',
  };

  aircraftDeviceOptions = [
    { value: null, label: 'Default'},
    { value: true, label: 'Yes'},
    { value: false, label: 'No'},
  ];

  get formIsReady() {
    let isReady = !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.featureUnitOptions);
    return isReady;
  }

  constructor(formBuilder: FormBuilder,
              private genericService: GenericResourceService,
              private router: Router,
              private featureService: FeatureTypeService,
              private featureGgwDeviceService: FeatureGgwDevicesService,
              private updateService: UpdateService) {
    super(formBuilder);
    this.setSubmitNullValueFields(['aircraft_device', 'include_exclude_for', 'option_token']);
  }

  protected afterUpdateForm(form) {
    if (this.schema) {
      this.updateIncludeExcludeOptions(this.schema.properties.include_exclude_for.choices);
    }
  }

  ngOnInit() {
    this.featureSubscription = this
      .featureService
      .getCurrent()
      .subscribe((feature: any) => {
          if (!isNullOrUndefined(feature)) {
              const units = this.featureService.extractUnitsFor(feature);
              console.log(units);
              this.feature = feature;
              this.updateFeatureUnitOptions(units);

              this.optionTokenSubscription = this.featureService.getOptionTokens(this.feature)
                .finally(() => this.optionTokenSubscription.unsubscribe())
                .subscribe((tokens: FeatureOptionToken[]) => {
                  this.optionTokens = tokens;
                  this.updateTokenOptions(this.optionTokens);
                });
          }
      });
  }

  ngOnDestroy() {
    this.featureSubscription.unsubscribe();
    if (this.optionTokenSubscription) {
      this.optionTokenSubscription.unsubscribe();
    }
  }

  onEntityReceived(entity) {
    this.currentResourceService = this.genericService.findServiceForResource(this.resourceUri);
  }

  refreshResource() {
    this.currentResourceService.refresh();
  }

  protected afterDelete() {
    this.featureService.refreshCurrent();
    this.router.navigate(['features', this.feature.id, 'properties']);
  }

  protected afterFormSubmit() {
    this.featureService.refreshCurrent();
  }

  private updateFeatureUnitOptions(linkedItems: any[]) {
    const optionList = [];
    linkedItems.forEach((item) => {
        optionList.push({label: item.label, value: item.href});
    });
    this.featureUnitOptions = optionList;
  }

  private updateIncludeExcludeOptions(choices: any[]) {
    const items: SelectItem[] = [];
    items.push({label: 'No', value: null});
    choices.forEach((choice: any) => {
      if (choice) {
        items.push({label: choice, value: choice});
      }
    });
    this.includeExcludeOptions = items;
  }

  private updateTokenOptions(tokens: FeatureOptionToken[]) {
    const items: SelectItem[] = [];
    items.push({label: '', value: null});
    tokens.forEach((token: FeatureOptionToken) => {
      console.log(token);
      items.push({label: token.value, value: token._links.self.href});
    });
    this.optionTokensOptions = items;
  }

  onConditionalChange($event: any) {
    if (isNullOrUndefined($event.value)) {
      this.form.patchValue({option_token: null});
    }
  }

  updateFromModel($event: any) {
    this.updateService.update(
      () => this.featureGgwDeviceService.updateFromModel(this.formData.id),
      () => this.refreshResource(),
      'ggw device');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-device/components/feature-ggw-device-form/feature-ggw-device-form.component.ts